import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { mediaUrl } from "../../../utils/clientHeroTheme";
import { Avatar } from "../../ui";
import s from "../clinic.module.css";

function previewText(text, max = 180) {
  const t = String(text || "").trim();
  if (!t) return "";
  return t.length > max ? `${t.slice(0, max).trim()}…` : t;
}

export default function ClubLifeRepostModal({
  post,
  open,
  busy = false,
  onClose,
  onConfirm,
}) {
  const [comment, setComment] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) {
      setComment("");
      const t = window.setTimeout(() => inputRef.current?.focus(), 120);
      return () => window.clearTimeout(t);
    }
    return undefined;
  }, [open, post?.id]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" && !busy) onClose?.();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, busy, onClose]);

  if (!open || !post) return null;

  const authorName = post.author?.full_name || "Автор";
  const previewBody = previewText(post.body || post.title);
  const previewPhoto = (post.media || []).find((m) => m.type !== "video");

  const submit = () => {
    if (busy) return;
    onConfirm(comment.trim());
  };

  return createPortal(
    <div
      className={s.repostSheetOverlay}
      role="dialog"
      aria-modal="true"
      aria-labelledby="repost-sheet-title"
      onClick={() => !busy && onClose?.()}
    >
      <div
        className={s.repostSheet}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={s.repostSheetHandle} aria-hidden />

        <header className={s.repostSheetHeader}>
          <button
            type="button"
            className={s.repostSheetHeaderBtn}
            onClick={onClose}
            disabled={busy}
          >
            Отмена
          </button>
          <h2 id="repost-sheet-title" className={s.repostSheetTitle}>
            Переслать на стену
          </h2>
          <button
            type="button"
            className={`${s.repostSheetHeaderBtn} ${s.repostSheetHeaderSend}`}
            onClick={submit}
            disabled={busy}
          >
            {busy ? "…" : "Отправить"}
          </button>
        </header>

        <div className={s.repostSheetCompose}>
          <textarea
            ref={inputRef}
            id="repost-comment"
            className={s.repostSheetInput}
            rows={2}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Добавьте комментарий…"
            maxLength={2000}
            disabled={busy}
          />
        </div>

        <p className={s.repostSheetPreviewLabel}>Запись</p>
        <div className={s.repostSheetBubble}>
          <div className={s.repostSheetBubbleInner}>
            <Avatar
              name={authorName}
              src={mediaUrl(post.author?.photo_url)}
              size="sm"
            />
            <div className={s.repostSheetBubbleBody}>
              <strong>{authorName}</strong>
              {post.title ? (
                <span className={s.repostSheetBubbleTitle}>{post.title}</span>
              ) : null}
              {previewBody ? <p>{previewBody}</p> : null}
              {previewPhoto?.url ? (
                <img
                  src={mediaUrl(previewPhoto.url)}
                  alt=""
                  className={s.repostSheetBubbleImg}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
